import { React, useState, useEffect } from 'react';
import './LoginWindow.scss';
import CountDownTimer from './CountDownTimer';
import Helper from '../../shared/common.helper';
import { Button, Link, FormLabel, TextInput } from 'carbon-components-react';

const OtpComponent = (props) => {
  const [authCode, setAuthCode] = useState('');
  const [isTimeOut, setIsTimeOut] = useState(false);
  const [isRestartTimer, setRestartTimer] = useState(false);

  const validateAuthcode = () => {
    console.log(authCode);
    return authCode &&
      authCode.trim() &&
      authCode.length > 5 &&
      authCode.length < 7 &&
      isNaN()
      ? false
      : true;
  };

  const onClickResendOtp = () => {
    props.onClickResendOtp(true);
    setRestartTimer(true);
    setIsTimeOut(false);
    setAuthCode('');
  };

  return (
    <div className="loginForm widget-styles">
      <div className="bx--grid">
        <div className="bx--row">
          <div className="bx--col-lg-6 bx--space loginTop_otp">
            <div>
              <br />
            </div>
            <header className="otpHeader">
              <h3>{props.t.login.otpTitle}</h3>
            </header>
            <br />
            <hr></hr>
            <br />
            <form
              method="post"
              onSubmit={(e) => {
                e.preventDefault();
                props.onSubmitotpEmail({
                  authCode: authCode,
                  e: e,
                });
              }}
            >
              <FormLabel>
                <span className="ibmIdfont">
                  {props.t.login.emailSent}{' '}
                  {Helper.replaceEmailWithFlower(props.userEmailAddress)}.
                </span>
              </FormLabel>
              <br />
              <br />
              <span className="ibmIdfont">
                {props.t.login.time}{' '}
                <CountDownTimer
                  isRestartTimer={isRestartTimer}
                  getCountDownTime={(e) => {
                    if (e < 1) {
                      setIsTimeOut(true);
                      setAuthCode('');
                    }
                  }}
                  resetTimerSuccess={(e) => {
                    setRestartTimer(e);
                    setIsTimeOut(e);
                  }}
                />
              </span>
              <br></br>
              <br />
              <br />
              <FormLabel>
                <span className="labelStyle">{props.t.login.password}</span>
              </FormLabel>
              <TextInput
                tabIndex={0}
                labelText=""
                autoComplete="off"
                placeholder=""
                onChange={(e) => setAuthCode(e.target.value)}
                id="authCode"
                invalid={props.isTwoFactorFailed}
                invalidText="You have entered wrong otp"
                value={authCode}
                required
                disabled={isTimeOut}
              />
              <br />
              <Button
                kind="tertiary"
                disabled={validateAuthcode()}
                onClick={(e) => {
                  e.preventDefault();
                  props.onSubmitotpEmail({
                    authCode: authCode,
                    e: e,
                  });
                }}
                className="loginButton"
              >
                {props.t.login.ContButton}
              </Button>
              <br />
              <br />
              <hr />
              <div className="bx--row">
                <div className="bx--col-lg-8 bx--space">
                  <Link onClick={() => onClickResendOtp()} href="javascript:;">
                    {props.t.login.Resend_otp}
                  </Link>
                  <br />
                  <br />
                  <Link
                    href="javascript:;"
                    onClick={() => props.backToPage(true)}
                  >
                    {' '}
                    {props.t.login.emailChange}
                  </Link>
                  <a href="/"></a>
                </div>
              </div>
            </form>
          </div>
          <div className="bx--col-lg-6 bx--space loginNoteBottom">
            <img
              src="login1.png"
              alt="login page lock icon"
              width="800"
              height="400"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default OtpComponent;
